// pages/Fete.js
import React, { useEffect } from 'react';
import Carousel from '../components/Carousel';

function SpectacleAMZ() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="fete-page">
      {/* Hero Section */}
      <div style={{
        padding: '80px 0 40px',
        textAlign: 'center',
        backgroundImage: 'url(/images/cover.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        width: '100%',
        marginLeft: 'calc(-50vw + 50%)',
        minHeight: '400px'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 1
        }}></div>

        <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>
          <style jsx>{`
            @media (max-width: 768px) {
              .fete-page > div:nth-child(1) {
                padding: 60px 0 30px !important;
                min-height: 300px !important;
              }
              .fete-page h1 {
                font-size: 2.5rem !important;
              }
            }
          `}</style>

          <img
            src="/images/Asset10.png"
            alt="Rights Expression Icon"
            style={{
              width: '80px',
              height: '80px',
              objectFit: 'contain'
            }}
          />

          <h1 style={{
            fontSize: '3.5rem',
            marginBottom: '20px',
            background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            textAlign: 'center'
          }}>
            ⵉⵡⵏⵏⵉⵜⵏ ⵏ ⵓⵣⵔⴼ
          </h1>

          <p style={{
            fontSize: '1.3rem',
            lineHeight: '1.9',
            marginBottom: '25px',
            color: 'var(--text-light)',
            textAlign: 'center'
          }}>
        ⵜⵉⴼⵉⵍⵉⵏ ⴷ ⵉⵙⵏⴼⵍⵓⵍⵏ ⵉⵏⵥⵓⵕⵏ ⵉ ⵓⵡⵏⵏⵉ ⵅⴰⴼ ⵉⵣⵔⴼⴰⵏ ⴷ ⵜⴷⵔⴼⵉⵏ
          </p>

          <div style={{
            background: 'var(--secondary-black)',
            padding: '20px 30px',
            borderRadius: '15px',
            borderRight: '4px solid var(--primary-orange)',
            marginBottom: '25px',
            direction:'ltr'
          }}>
            <p style={{ fontSize: '1.3rem', marginBottom: '10px' }}>
              <img src="/images/calandarv.png" className="tab-icon3-img" alt="Calendar" />
              <strong>ⴰⵙⵙ:</strong> 10 ⴷⵓⵊⴰⵏⴱⵉⵔ 2025
            </p>
            <p style={{ fontSize: '1.3rem' }}>
              <img src="/images/location.png" className="tab-icon3-img" alt="Location" />
              <strong>ⴰⴷⵖⴰⵔ:</strong> ⵔⴰⴷ ⵉⵜⵜⵓⵙⵡⵓⵜⵜⵓ ⵓⴷⵖⴰⵔ ⴳ ⵎⴰⴷ ⵢⴰⵥⵏ...
            </p>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0' }}>
        <div className="container">

          {/* Introduction */}
          <div style={{ marginBottom: '60px' }}>
            <h2 style={{
              fontSize: '2.5rem',
              marginBottom: '30px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              ⵉ ⵜⵎⵢⴰⴳⴰⵏⵜ ⵏ ⵉⵣⵔⴼⴰⵏ
            </h2>

            <div style={{
              background: 'var(--primary-black)',
              padding: '40px',
              borderRadius: '15px',
              border: '2px solid rgba(255, 107, 53, 0.3)',
              marginBottom: '40px'
            }}>
              <p style={{
                fontSize: '1.2rem',
                lineHeight: '2',
                color: 'var(--text-light)',
                marginBottom: '25px',
                textAlign: 'center'
              }}>
              ⵉⵡⵏⵏⵉⵜⵏ ⵏ ⵓⵣⵔⴼ, ⵜⴰⴼⵓⴳⵍⴰ ⵜⴰⵙⴳⵯⵙⴰⵏⵜ ⵉⵙⴼⵓⴳⵍⵓⵏ ⵙ ⵉⵣⵔⴼⴰⵏ ⴷ ⵉⵡⵏⵏⵉⵜⵏ, ⵔⴰⴷ ⵉⵙⵎⴷ ⴰⵙⴳⴳⵯⴰⵙ ⴰⴷ ⵙ ⵓⵎⵣⵉⵣⵣⵍ ⴰⵏⴰⵎⵓⵔ ⵏ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ (25 ⵏⵓⵡⴰⵏⴱⵉⵔ - 10 ⴷⵓⵊⴰⵏⴱⵉⵔ)
              </p>

              <p style={{
                fontSize: '1.2rem',
                lineHeight: '2',
                color: 'var(--text-light)',
                marginBottom: '25px',
                textAlign: 'center'
              }}>
              ⵜⴰⴼⵓⴳⵍⴰ ⵜⴰⵎⴳⴳⴰⵔⵓⵜ, ⴳ ⵓⵙⴰⵢⵔⴰⵔ ⵉⵕⵥⵎⵏ ⴷ ⵉⵏⵏⵓⵕⵥⵎⵏ ⵅⴼ ⵉⵡⵏⵏⵉⵜⵏ ⵏ ⵓⵣⵔⴼ
      </p>

              <p style={{
                fontSize: '1.2rem',
                lineHeight: '2',
                color: 'var(--text-light)',
                textAlign: 'center'
              }}>
          ⵜⴰⵥⵓⵕⵉ, ⵙ ⴰⴽⴽⵯ ⵜⵉⵡⵉⵍⴰⵜⵉⵏ ⵏⵏⵙ ⴷ ⵉⵡⵏⵏⵉⵜⵏ ⵏⵏⵙ, ⵓⵔ ⴷ ⵖⴰⵙ ⴰⵡⵏⵏⵉ ⵏ ⵓⴼⵓⵍⴽⵉ ⴷ ⵓⵙⵏⴼⵍⵓⵍ, ⵎⴰⵛ ⵜⴰⵎⵙⵙⵉⵍⵉⵜ ⵉ ⵉⵣⵔⴼⴰⵏ ⴷ ⵜⴷⵔⴼⵉⵏ ⴷ ⵓⵙⵇⵙⵉ ⵏ ⵜⴽⵕⴹⵉ, ⴷ ⵓⵕⵥⵥⵓⵎ ⵏ ⵉⵣⴰⵔⵓⵜⵏ ⵉⵎⴰⵢⵏⵓⵜⵏ ⵉ ⵓⵙⵡⵉⵏⴳⵎ ⴷ ⵓⴼⵔⴰⴽ    </p>
            </div>
          </div>



          <div className="section-separator"></div>

          {/* Call to Action */}
          <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '25px',
              color: 'var(--white)',
              textAlign: 'center'
            }}>
              ⴰⵎⵓⵢⴰⵜ ⴷⵉⴷⵏⵖ ⴳ ⵜⴼⵓⴳⵍⴰ
            </h3>
            <p style={{
              fontSize: '1.3rem',
              marginBottom: '30px',
              color: 'var(--text-light)',
              lineHeight: '1.8',
              maxWidth: '800px',
              margin: '0 auto 30px',
              textAlign: 'center'
            }}>
              ⴳⴰⵜ ⴰⴳⵣⵣⵓⵎ ⴳ ⵉⵎⵊⵕⵉ ⴰⴷ ⴰⵎⵣⵔⴰⵢ, ⵜⴷⵔⵓⵎ ⴳ ⵜⵓⵚⴽⴰ ⵏ ⵡⴰⵎⵓⵏ ⴳ ⵍⴰⵃ ⵜⵉⴽⵕⴹⵉ
            </p>


            <p style={{
              fontSize: '1.2rem',
              marginTop: '30px',
              color: 'var(--text-light)',
              fontStyle: 'italic',
              textAlign: 'center'
            }}>
              ⴽⵓⵍⵍⵓ ⴰⵖ ⴰⴷ ⵏⵙⵉⵡⵍ ⵅⴼ ⵓⵣⵔⴼ  | ⴽⵓⵍⵍⵓ ⴰⵖ ⴰⴷ ⵏⵚⴽⵓ ⵉⵎⴰⵍ
            </p>
          </div>
        </div>
      </div>

      <Carousel />
    </div>
  );
}

export default SpectacleAMZ;
